import { CurrencyState } from '@/features/shared/currency-store';

export const currencySelectors = {
  currency: (state: CurrencyState) => state.currentCurrency,
  country: (state: CurrencyState) => state.countryISO,
  setRegion: (state: CurrencyState) => state.setRegion,
};
